import { Box, BoxProps } from '@pancakeswap/uikit'

const Container: React.FC<React.PropsWithChildren<BoxProps>> = ({ children, ...props }) => (
  <Box px={['8px', '8px']} mx="auto" maxWidth="1200px" {...props}>
    {children}
  </Box>
)

export default Container
